import mount from "../utils/mount";
import Template48306Container from "./Template48306Container";

import "./css/all.css";
import "./css/custom.css";

mount(Template48306Container);
